import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "41.013",
  height: "50",
  viewBox: "0 0 41.013 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M20.506 0a2 2 0 0 0-1.165.38C10.43 7.063 1.822 8.076 1.72 8.076.707 8.176 0 8.987 0 10v19.34c0 9.419 17.52 19.342 19.544 20.456.304.101.606.204.91.204.304 0 .608-.001 1.013-.204.202-.101 4.76-2.632 9.52-6.278 6.683-5.164 10.025-9.924 10.025-14.177v-19.34c0-1.013-.708-1.824-1.72-1.925-.102 0-8.71-.911-17.621-7.696A2 2 0 0 0 20.506 0zm-.051 4.227c7.088 5.063 13.67 6.785 16.709 7.393v17.722c0 2.937-3.037 6.886-8.505 11.139-3.342 2.531-6.685 4.557-8.204 5.469C13.569 42 3.745 34.507 3.745 29.342V11.62c3.039-.608 9.621-2.33 16.71-7.394zm9.519 11.139L17.721 27.619l-4.962-4.96-3.14 3.037 8.102 8.101 15.291-15.393z"
  })]
});